import { createContext, useContext, useState, type ReactNode } from "react";

interface MapPreviewCtx {
  geoJSON: object | null;
  setGeoJSON: (d: object | null) => void;
  mapOpen: boolean;
  setMapOpen: (o: boolean) => void;
}

const MapPreviewContext = createContext<MapPreviewCtx>({
  geoJSON: null,
  setGeoJSON: () => {},
  mapOpen: false,
  setMapOpen: () => {},
});

export const MapPreviewProvider = ({ children }: { children: ReactNode }) => {
  const [geoJSON, setGeoJSON] = useState<object | null>(null);
  const [mapOpen, setMapOpen] = useState(false);

  return (
    <MapPreviewContext.Provider value={{ geoJSON, setGeoJSON, mapOpen, setMapOpen }}>
      {children}
    </MapPreviewContext.Provider>
  );
};

export const useMapPreview = () => useContext(MapPreviewContext);
